// extracted by mini-css-extract-plugin
export default {"BrandContainer":"Brand_BrandContainer__0Pfsk","Brand":"Brand_Brand__t-ACS","BrandItem":"Brand_BrandItem__VWCTK"};